import { useEffect, useState } from "react";
import { _DocumentFactory, _single } from "../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { PrintJson } from "../theme/Component/PrintJson";
import { DocumentViewer } from "../theme/Component/DocumentViewer";

interface Props{
    Year?:number;
    Mnemonic:string;
    Consecutive:number;
    ConsecutiveExt?:number;

}
export const VisorDocumentFactory=({Year,Mnemonic,Consecutive,ConsecutiveExt}:Props)=>{

    const _document = useDataBean(_DocumentFactory);
    const {lista,setLista,bean,setBean} = _document;
    const [document,setDocument] = useState<any>([]);

    useEffect(()=>{
        getDocument();
    },[Mnemonic,Consecutive,ConsecutiveExt])

    const getDocument = () =>{
        _document.instance.getDocumentsAndConsecutive(Year ?? _single.getCurrenYear(),Mnemonic,Consecutive,_single.getAccountID(),null,null,ConsecutiveExt ?? null).then(
            (resp:any)=>{              
                if(resp.length>0)
                    {
                        let doc = resp[0].DataBeanProperties;
                        _document.instance.getPdfAccountantDocument(doc.IDDocument,doc.Mnemonic,doc.DocumentDate,_single.getAccountID()).then(
                            (resp:any)=>{

                                setDocument(resp.DocumentURL);
                            }
                        )
                        setDocument(doc);     
                    }                                        
            }
        )
    }

    return(
        <div className="row">
            <div className="col-md-12">
                <DocumentViewer list={document}/>
                {/* <PrintJson json={document}/> */}
            </div>
        </div>
    )
}